<template>
  <svg
    viewBox="0 0 120 120"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    class="size-full"
  >
    <!-- Background blob -->
    <circle
      cx="60"
      cy="60"
      r="50"
      fill="currentColor"
      opacity="0.04"
      stroke="none"
    />

    <!-- License card — tilted slightly for dynamism -->
    <g transform="rotate(-4, 60, 56)">
      <!-- Card body -->
      <rect
        x="22"
        y="32"
        width="76"
        height="48"
        rx="6"
        ry="6"
        stroke-width="2"
      />
      <rect
        x="22"
        y="32"
        width="76"
        height="48"
        rx="6"
        ry="6"
        fill="currentColor"
        opacity="0.05"
        stroke="none"
      />

      <!-- Card header stripe -->
      <rect
        x="22"
        y="32"
        width="76"
        height="10"
        rx="6"
        ry="6"
        fill="currentColor"
        opacity="0.06"
        stroke="none"
      />
      <line
        x1="22"
        y1="42"
        x2="98"
        y2="42"
        opacity="0.08"
        stroke-width="1"
      />

      <!-- Photo area -->
      <rect
        x="28"
        y="46"
        width="18"
        height="22"
        rx="3"
        ry="3"
        fill="currentColor"
        opacity="0.06"
        stroke-width="1"
      />

      <!-- Person silhouette in photo -->
      <circle
        cx="37"
        cy="52"
        r="4"
        opacity="0.12"
        stroke-width="1.5"
      />
      <path
        d="M30 65 C30 60 33 57 37 57 C41 57 44 60 44 65"
        opacity="0.12"
        stroke-width="1.5"
      />

      <!-- Name line -->
      <line
        x1="52"
        y1="49"
        x2="84"
        y2="49"
        stroke-width="1.5"
        opacity="0.4"
      />

      <!-- Detail lines -->
      <line
        x1="52"
        y1="55"
        x2="76"
        y2="55"
        opacity="0.25"
        stroke-width="1"
      />
      <line
        x1="52"
        y1="60"
        x2="80"
        y2="60"
        opacity="0.2"
        stroke-width="1"
      />
      <line
        x1="52"
        y1="65"
        x2="72"
        y2="65"
        opacity="0.15"
        stroke-width="1"
      />

      <!-- Category badge -->
      <rect
        x="28"
        y="72"
        width="10"
        height="5"
        rx="1.5"
        fill="currentColor"
        opacity="0.07"
        stroke-width="1"
      />
      <text
        x="33"
        y="76"
        text-anchor="middle"
        font-size="3.5"
        fill="currentColor"
        opacity="0.25"
        stroke="none"
        font-weight="600"
      >B</text>

      <!-- Chip -->
      <rect
        x="80"
        y="71"
        width="8"
        height="5"
        rx="1"
        fill="currentColor"
        opacity="0.06"
        stroke-width="1"
      />
      <line
        x1="81"
        y1="73.5"
        x2="87"
        y2="73.5"
        opacity="0.1"
        stroke-width="0.5"
      />
      <line
        x1="84"
        y1="71.5"
        x2="84"
        y2="75.5"
        opacity="0.1"
        stroke-width="0.5"
      />
    </g>

    <!-- Circular refresh arrows — surrounding the card -->
    <!-- Top-right arc -->
    <path
      d="M88 22 A38 38 0 0 1 102 48"
      stroke-width="2.5"
      opacity="0.3"
      fill="none"
    />
    <!-- Arrow head top-right -->
    <path
      d="M99 42 L102 48 L96 48"
      stroke-width="2"
      opacity="0.3"
      fill="currentColor"
    />

    <!-- Bottom-left arc -->
    <path
      d="M32 98 A38 38 0 0 1 18 72"
      stroke-width="2.5"
      opacity="0.3"
      fill="none"
    />
    <!-- Arrow head bottom-left -->
    <path
      d="M21 78 L18 72 L24 72"
      stroke-width="2"
      opacity="0.3"
      fill="currentColor"
    />

    <!-- Decorative dots suggesting process/motion -->
    <circle
      cx="82"
      cy="18"
      r="2"
      fill="currentColor"
      opacity="0.1"
      stroke="none"
    />
    <circle
      cx="108"
      cy="56"
      r="1.5"
      fill="currentColor"
      opacity="0.07"
      stroke="none"
    />
    <circle
      cx="38"
      cy="102"
      r="2"
      fill="currentColor"
      opacity="0.1"
      stroke="none"
    />
    <circle
      cx="12"
      cy="64"
      r="1.5"
      fill="currentColor"
      opacity="0.07"
      stroke="none"
    />
  </svg>
</template>
